export class ImportLinesCount {
  constructor(
    public readonly found: number | null,
    public readonly inserted: number | null,
    public readonly updated: number | null,
    public readonly ignored: number | null
  ) {}
}
